module.exports = __webpack_public_path__ + "assets/serviceimg3.51dd85e2.svg";